import $ from 'jquery'
import { toolkitUrls } from '@/links'

export { getUserDownloads, saveUserDownload }

function getUserDownloads(settings) {
  var param = $.param(settings)
  return $.ajax({
    url: `${toolkitUrls.api}/collections?${param}`,
    method: 'GET',
    contentType: 'json',
    xhrFields: { withCredentials: true }
  })
}

function saveUserDownload(resource) {
  return $.ajax({
    url: `${toolkitUrls.api}/collections`,
    data: JSON.stringify(resource),
    method: 'POST',
    contentType: 'json',
    xhrFields: { withCredentials: true }
  })
}
